import React, { useEffect, useState } from 'react';
import { isPreviewDetail } from '../../utils/browserUtils';
import './ModifySearch.css';
import ModifySearchContext from './ModifySearchContext';

const ModifySearch = ({ fullPage = true, children, captureOmnitureClick }) => {
  const [activeControl, setActiveControl] = useState(null);
  const close = () => {
    setActiveControl(null);
  };

  useEffect(() => {
    activeControl && captureOmnitureClick?.(`select_${activeControl}`);
  }, [activeControl]);

  return (
    <div
      id="modifySearchDetails"
      className={`modify-search_container showWithAnimate ${
        isPreviewDetail() ? 't-pointer-none' : ''
      }`}
    >
      <div className={`modify-search_inner-container ${fullPage ? 'fullPage' : ''}`}>
        <ModifySearchContext.Provider value={{ activeControl, setActiveControl }}>
          {children}
        </ModifySearchContext.Provider>
        {activeControl !== null && (
          <div
            className={`modify-search_backdrop ${activeControl !== null ? 'active' : ''}`}
            onClick={close}
          />
        )}
      </div>
    </div>
  );
};

export default ModifySearch;
